import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from 'react-icons/fa';
import InternalHeader from '../InternalHeader';
import Sidebar from '../Sidebar';
import '../Patients/CreatePatient.css'; // Assuming you're using the same CSS
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AccessControl from '../AccessControl';
import LinkMap from '../LinkMap/LinkMap';

const CreateInventory = () => {
    const navigate = useNavigate();
    const [stores, setStores] = useState([]);
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const [newItem, setNewItem] = useState({
        Name: "",
        Quantity: "",
        Price: "",
        Unit: "kg", // Default unit
        Store: "",
        CriticalStock: "",
    });
    const [categories, setCategories] = useState([]);
    const linkData = [
        { label: 'Inventory', path: '/inventory' },
        { label: 'Create Inventory', path: '/create-inventory' },
    ];

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch('https://api.hgcdental.clinic/api/category');
                if (!response.ok) throw new Error('Failed to fetch categories');
                const data = await response.json();

                // Filter out archived categories (isArchived === true)
                const activeCategories = data.filter(category => !category.isArchived);

                setCategories(activeCategories);
            } catch (error) {
                console.error(error);
            }
        };
        fetchCategories();
    }, []);


    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Only parse currency for the Price field
        if (name === "Price") {
            const parsedValue = parseCurrency(value);
            setNewItem({
                ...newItem,
                [name]: parsedValue,
            });
        } else {
            // For all other fields, update the state directly
            setNewItem({
                ...newItem,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://api.hgcdental.clinic/api/inventory', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newItem),
            });

            const data = await response.json();
            // onAddItem(data);

            if (response.ok) {
                window.alert('Item added successfully!');
                navigate('/inventory');
            }

        } catch (error) {
            console.error('Error adding item:', error);
        }
    };

    const formatCurrency = (value) => {
        if (!value) return ""; // Handle empty values
        // Remove non-numeric characters and parse as float
        const number = parseFloat(value.toString().replace(/[^0-9.]/g, ""));
        if (isNaN(number)) return ""; // Handle invalid numbers
        // Format the number with commas and two decimal places
        return new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(number);
    };

    const parseCurrency = (value) => {
        if (!value) return 0; // Handle empty values
        // Remove commas and parse as float
        return parseFloat(value.replace(/,/g, ""));
    };

    useEffect(() => {
        axios.get('https://api.hgcdental.clinic/api/stores')
            .then(response => {
                setStores(response.data);
            })
            .catch(error => {
                console.error('Error fetching stores:', error);
            });
    }, []);

    return (
        <AccessControl>
            <div className={`create-patient-container ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
                <InternalHeader moduleName="Create Inventory Item" toggleSidebar={toggleSidebar} />
                <div className="create-patient-content">
                    <Sidebar isSidebarVisible={isSidebarVisible} />
                    <div className="create-patient">
                        <LinkMap
                            links={linkData}
                            moduleName="Inventory"
                            moduleIcon="inventory"
                        />
                        <div>
                            <button className="create-patient-button" onClick={handleSubmit}>
                                <FaSave /> Save
                            </button>
                        </div>
                        <div className="create-patient-form">
                            <h2>Create New Inventory Item</h2>

                            {/* Name Field */}
                            <div className="input-group">
                                <label className="label">Name</label>
                                <input
                                    type="text"
                                    name="Name"
                                    value={newItem.Name}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>

                            {/* Quantity Field */}
                            <div className="input-group">
                                <label className="label">Quantity</label>
                                <input
                                    type="number"
                                    name="Quantity"
                                    value={newItem.Quantity}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>

                            {/* Unit Field */}
                            <div className="input-group">
                                <label className="label">Unit</label>
                                <select
                                    name="Unit"
                                    value={newItem.Unit}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                >
                                    <option value="kg">kg</option>
                                    <option value="g">g</option>
                                    <option value="L">L</option>
                                    <option value="mL">mL</option>
                                    <option value="units">units</option>
                                    <option value="pieces">pieces</option>
                                </select>
                            </div>

                            {/* Price Field */}
                            <div className="input-group">
                                <label className="label">Price</label>
                                <input
                                    type="text"
                                    name="Price"
                                    value={formatCurrency(newItem.Price)} // Format the value for display
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>

                            {/* Critical Stock Field */}
                            <div className="input-group">
                                <label className="label">Critical Stock</label>
                                <input
                                    type="number"
                                    name="CriticalStock"
                                    value={newItem.CriticalStock}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                />
                            </div>

                            {/* Store Dropdown Field */}
                            <div className="input-group">
                                <label className="label">Supplier</label>
                                <select
                                    name="Store"
                                    value={newItem.Store}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                >
                                    <option value="">Select a supplier</option>
                                    {stores.map(store => (
                                        <option key={store._id} value={store._id}>
                                            {store.StoreName} ({store.StoreContact})
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Category Dropdown Field */}
                            <div className="input-group">
                                <label className="label">Category</label>
                                <select
                                    name="Category"
                                    value={newItem.Category}
                                    onChange={handleInputChange}
                                    className="input-field"
                                    required
                                >
                                    <option value="">Select a category</option>
                                    {categories.map(category => (
                                        <option key={category._id} value={category._id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AccessControl>
    );
};

export default CreateInventory;